import { useQuery } from "react-query";
import { useUser } from "stores/useUser";
import { ONEDAY } from "utils/common";
import { getMyOrgInsights } from "utils/insights";

const useInsights = () => {
  const { user } = useUser();
  const {
    data: myOrgData,
    isLoading: isMyOrgLoading,
    isError: isMyOrgError,
  } = useQuery({
    queryKey: "MyOrgInsights",
    queryFn: () => getMyOrgInsights(user?.uid),
    staleTime: ONEDAY, // 1 day in milliseconds
  });

  return {
    myOrgData,
    isMyOrgLoading,
    isMyOrgError,
  };
};

export default useInsights;
